// Team Insights — AI / manual mastering + history strings (prefix `ins.mst.`)
const en = {
  "ins.mst.aiDesc": "Upload a mix — the AI detects the genre, builds a mastering chain and renders a streaming-ready WAV.",
  "ins.mst.manualTitle": "Mastering Studio",
  "ins.mst.manualDesc": "Shape the chain yourself and compare against the original in real time.",
  "ins.mst.history": "History",
  "ins.mst.manual": "Manual studio",
  "ins.mst.newFile": "New file",
  "ins.mst.progress": "Progress",
  "ins.mst.step.upload": "Upload",
  "ins.mst.step.process": "Analyse & master",
  "ins.mst.step.done": "Compare & download",
  "ins.mst.dropAria": "Choose an audio file to master",
  "ins.mst.dropTitle": "Drop your mix here or click to browse",
  "ins.mst.clickToChange": "click to change",
  "ins.mst.unsupported": "Unsupported format. Supported: {formats}",
  "ins.mst.effect": "Creative effect (optional)",
  "ins.mst.start": "Start AI mastering",
  "ins.mst.outputNote": "Output: WAV, same sample rate as your upload.",
  "ins.mst.howTitle": "How it works",
  "ins.mst.how1": "We measure loudness (LUFS), dynamics, tempo and tonal balance of your mix.",
  "ins.mst.how2": "The closest genre profile sets EQ, compression, saturation, stereo width, limiter and loudness target.",
  "ins.mst.how3": "You compare original vs master with gapless A/B and download the WAV.",
  "ins.mst.wantControl": "Want full control? Open the manual studio",
  "ins.mst.recent": "Recent masters",
  "ins.mst.viewAll": "View all",
  "ins.mst.noJobs": "No masters yet — your first one will appear here.",
  "ins.mst.uploading": "Uploading… {pct}%",
  "ins.mst.processing": "Analysing & mastering…",
  "ins.mst.elapsed": "Elapsed {time}",
  "ins.mst.processingNote": "Long tracks can take a minute or two. Keep this tab open.",
  "ins.mst.processed": "Your master is ready",
  "ins.mst.processFailed": "Mastering failed. Please try again.",
  "ins.mst.audioLoadFailed": "Couldn't load the audio for playback.",
  "ins.mst.jobLoadFailed": "Couldn't open this mastering job.",
  "ins.mst.downloadFailed": "Download failed. Please try again.",
  "ins.mst.player": "Player",
  "ins.mst.completed": "Completed",
  "ins.mst.detected": "Detected style",
  "ins.mst.confidence": "Confidence",
  "ins.mst.estimatedTip": "Heuristic estimate from the audio analysis — treat it as guidance, not a measurement.",
  "ins.mst.analysisFallback": "Automatic analysis failed for this file, so a default Pop profile was applied.",
  "ins.mst.genreScores": "Genre match",
  "ins.mst.whatWeDid": "What the AI adjusted",
  "ins.mst.rec.loud": "Your mix was already loud — the limiter was applied carefully.",
  "ins.mst.rec.quiet": "Your mix was quiet — a significant loudness increase was applied.",
  "ins.mst.rec.wideDynamics": "Wide dynamic range detected — compression was increased.",
  "ins.mst.rec.heavyBass": "Heavy low end detected — EQ was adjusted to control the bass.",
  "ins.mst.rec.bright": "Bright top end detected — high frequencies were softened slightly.",
  "ins.mst.rec.noisy": "Noisy content detected — gentler processing was used.",
  "ins.mst.inputLoudness": "Input loudness",
  "ins.mst.dynamicRange": "Dynamic range",
  "ins.mst.brightness": "Brightness",
  "ins.mst.energy": "Energy distribution",
  "ins.mst.low": "Low",
  "ins.mst.mid": "Mid",
  "ins.mst.high": "High",
  "ins.mst.beforeAfter": "Before / after",
  "ins.mst.integrated": "Integrated loudness",
  "ins.mst.truePeak": "True peak",
  "ins.mst.samplePeak": "Sample peak",
  "ins.mst.duration": "Duration",
  "ins.mst.target": "Loudness target",
  "ins.mst.peakWarn": "True peak above −1 dBTP may distort after streaming encoding.",
  "ins.mst.noWaveform": "Waveform not available for this file",
  "ins.mst.waveform": "Waveform — use arrow keys to seek",
  "ins.mst.appliedChain": "Applied chain",
  "ins.mst.bands": "{n} bands",
  "ins.mst.downloadMaster": "Download master (WAV)",
  "ins.mst.downloadOriginal": "Download original",
  "ins.mst.fineTune": "Fine-tune in manual studio",
  "ins.mst.restart": "Back to start",
  "ins.mst.play": "Play",
  "ins.mst.pause": "Pause",
  "ins.mst.abCompare": "A/B comparison",
  "ins.mst.abHint": "Press A for the original and B for the master — playback continues at the same moment.",
  "ins.mst.uploaded": "File uploaded and analysed",
  "ins.mst.uploadFailed": "Upload failed. Please check the file and try again.",
  "ins.mst.analyzing": "Uploading & analysing…",
  "ins.mst.custom": "Custom",
  "ins.mst.render": "Render master",
  "ins.mst.rerender": "Re-render",
  "ins.mst.rendering": "Rendering…",
  "ins.mst.dirty": "Settings changed since the last render — re-render to hear them.",
  "ins.mst.startFrom": "Start from",
  "ins.mst.genrePreset": "Genre preset…",
  "ins.mst.neutral": "Neutral",
  "ins.mst.revert": "Revert to last render",
  "ins.mst.mod.eq": "Equalizer",
  "ins.mst.mod.compressor": "Compressor",
  "ins.mst.mod.limiter": "Limiter",
  "ins.mst.mod.stereo": "Stereo width",
  "ins.mst.mod.saturation": "Saturation",
  "ins.mst.mod.loudness": "Loudness normalisation",
  "ins.mst.eqCurve": "EQ curve — drag the points to adjust",
  "ins.mst.lowCut": "Low cut",
  "ins.mst.freq": "Freq",
  "ins.mst.gain": "Gain",
  "ins.mst.bandType.lowShelf": "Low shelf",
  "ins.mst.bandType.peaking": "Bell",
  "ins.mst.bandType.highShelf": "High shelf",
  "ins.mst.threshold": "Threshold",
  "ins.mst.ratio": "Ratio",
  "ins.mst.makeup": "Makeup",
  "ins.mst.attack": "Attack",
  "ins.mst.release": "Release",
  "ins.mst.knee": "Knee",
  "ins.mst.ceiling": "Ceiling",
  "ins.mst.width": "Width",
  "ins.mst.monoBass": "Mono bass",
  "ins.mst.drive": "Drive",
  "ins.mst.satType": "Saturation type",
  "ins.mst.sat.tape": "Tape",
  "ins.mst.sat.tube": "Tube",
  "ins.mst.sat.digital": "Soft clip",
  "ins.mst.loudnessHint": "Final gain stage to hit the target. −14 LUFS matches Spotify, YouTube and Apple Music normalisation.",
  "ins.mst.meterShowing": "Meter shows: {source}",
  "ins.mst.historyTitle": "Mastering history",
  "ins.mst.historyDesc": "All your AI and manual masters, stored on your account.",
  "ins.mst.kpiTotal": "Total masters",
  "ins.mst.kpiMinutes": "Minutes mastered",
  "ins.mst.typeAi": "AI",
  "ins.mst.typeManual": "Manual",
  "ins.mst.all": "All",
  "ins.mst.filter": "Filter by type",
  "ins.mst.search": "Search by file name",
  "ins.mst.emptyTitle": "No masters yet",
  "ins.mst.emptyDesc": "Master your first track with AI in a couple of minutes — it will be saved here.",
  "ins.mst.noMatch": "No masters match your filters.",
  "ins.mst.colFile": "File",
  "ins.mst.colType": "Type",
  "ins.mst.colLoudness": "Loudness",
  "ins.mst.colStatus": "Status",
  "ins.mst.colActions": "Actions",
  "ins.mst.notRendered": "Not rendered",
  "ins.mst.open": "Open",
  "ins.mst.deleted": "Master deleted",
  "ins.mst.deleteFailed": "Couldn't delete this master.",
  "ins.mst.deleteTitle": "Delete this master?",
  "ins.mst.deleteDesc": "\"{name}\" and its mastered file will be permanently deleted.",
};

const tr = {
  "ins.mst.aiDesc": "Mix'inizi yükleyin — yapay zekâ türü algılar, mastering zincirini kurar ve yayına hazır bir WAV oluşturur.",
  "ins.mst.manualTitle": "Mastering Stüdyosu",
  "ins.mst.manualDesc": "Zinciri kendiniz şekillendirin ve orijinalle anlık karşılaştırın.",
  "ins.mst.history": "Geçmiş",
  "ins.mst.manual": "Manuel stüdyo",
  "ins.mst.newFile": "Yeni dosya",
  "ins.mst.progress": "İlerleme",
  "ins.mst.step.upload": "Yükle",
  "ins.mst.step.process": "Analiz ve mastering",
  "ins.mst.step.done": "Karşılaştır ve indir",
  "ins.mst.dropAria": "Mastering için bir ses dosyası seçin",
  "ins.mst.dropTitle": "Mix'inizi buraya bırakın veya seçmek için tıklayın",
  "ins.mst.clickToChange": "değiştirmek için tıklayın",
  "ins.mst.unsupported": "Desteklenmeyen format. Desteklenenler: {formats}",
  "ins.mst.effect": "Yaratıcı efekt (isteğe bağlı)",
  "ins.mst.start": "AI mastering'i başlat",
  "ins.mst.outputNote": "Çıktı: WAV, yüklediğiniz dosyayla aynı örnekleme hızında.",
  "ins.mst.howTitle": "Nasıl çalışır",
  "ins.mst.how1": "Mix'inizin ses yüksekliğini (LUFS), dinamiklerini, temposunu ve tonal dengesini ölçeriz.",
  "ins.mst.how2": "En yakın tür profili EQ, kompresyon, saturasyon, stereo genişlik, limiter ve loudness hedefini belirler.",
  "ins.mst.how3": "Orijinal ile master'ı kesintisiz A/B ile karşılaştırır ve WAV'ı indirirsiniz.",
  "ins.mst.wantControl": "Tam kontrol mü istiyorsunuz? Manuel stüdyoyu açın",
  "ins.mst.recent": "Son masterlar",
  "ins.mst.viewAll": "Tümünü gör",
  "ins.mst.noJobs": "Henüz master yok — ilki burada görünecek.",
  "ins.mst.uploading": "Yükleniyor… %{pct}",
  "ins.mst.processing": "Analiz ediliyor ve master'lanıyor…",
  "ins.mst.elapsed": "Geçen süre {time}",
  "ins.mst.processingNote": "Uzun parçalar bir iki dakika sürebilir. Bu sekmeyi açık tutun.",
  "ins.mst.processed": "Master'ınız hazır",
  "ins.mst.processFailed": "Mastering başarısız oldu. Lütfen tekrar deneyin.",
  "ins.mst.audioLoadFailed": "Ses oynatma için yüklenemedi.",
  "ins.mst.jobLoadFailed": "Bu mastering işi açılamadı.",
  "ins.mst.downloadFailed": "İndirme başarısız. Lütfen tekrar deneyin.",
  "ins.mst.player": "Oynatıcı",
  "ins.mst.completed": "Tamamlandı",
  "ins.mst.detected": "Algılanan tarz",
  "ins.mst.confidence": "Güven",
  "ins.mst.estimatedTip": "Ses analizinden elde edilen sezgisel bir tahmindir — ölçüm değil, yol gösterici olarak değerlendirin.",
  "ins.mst.analysisFallback": "Bu dosya için otomatik analiz başarısız oldu, varsayılan Pop profili uygulandı.",
  "ins.mst.genreScores": "Tür eşleşmesi",
  "ins.mst.whatWeDid": "Yapay zekânın ayarladıkları",
  "ins.mst.rec.loud": "Mix'iniz zaten yüksekti — limiter dikkatli uygulandı.",
  "ins.mst.rec.quiet": "Mix'iniz sessizdi — belirgin bir ses yüksekliği artışı uygulandı.",
  "ins.mst.rec.wideDynamics": "Geniş dinamik aralık tespit edildi — kompresyon artırıldı.",
  "ins.mst.rec.heavyBass": "Ağır bas tespit edildi — bas kontrolü için EQ ayarlandı.",
  "ins.mst.rec.bright": "Parlak tizler tespit edildi — yüksek frekanslar hafifçe yumuşatıldı.",
  "ins.mst.rec.noisy": "Gürültülü içerik tespit edildi — daha yumuşak işleme kullanıldı.",
  "ins.mst.inputLoudness": "Giriş ses yüksekliği",
  "ins.mst.dynamicRange": "Dinamik aralık",
  "ins.mst.brightness": "Parlaklık",
  "ins.mst.energy": "Enerji dağılımı",
  "ins.mst.low": "Bas",
  "ins.mst.mid": "Orta",
  "ins.mst.high": "Tiz",
  "ins.mst.beforeAfter": "Önce / sonra",
  "ins.mst.integrated": "Entegre ses yüksekliği",
  "ins.mst.truePeak": "Gerçek tepe",
  "ins.mst.samplePeak": "Örnek tepe",
  "ins.mst.duration": "Süre",
  "ins.mst.target": "Loudness hedefi",
  "ins.mst.peakWarn": "−1 dBTP üzerindeki gerçek tepe, yayın kodlamasından sonra bozulmaya yol açabilir.",
  "ins.mst.noWaveform": "Bu dosya için dalga formu yok",
  "ins.mst.waveform": "Dalga formu — sarmak için ok tuşlarını kullanın",
  "ins.mst.appliedChain": "Uygulanan zincir",
  "ins.mst.bands": "{n} bant",
  "ins.mst.downloadMaster": "Master'ı indir (WAV)",
  "ins.mst.downloadOriginal": "Orijinali indir",
  "ins.mst.fineTune": "Manuel stüdyoda ince ayar yap",
  "ins.mst.restart": "Başa dön",
  "ins.mst.play": "Oynat",
  "ins.mst.pause": "Duraklat",
  "ins.mst.abCompare": "A/B karşılaştırma",
  "ins.mst.abHint": "Orijinal için A, master için B'ye basın — çalma aynı anda devam eder.",
  "ins.mst.uploaded": "Dosya yüklendi ve analiz edildi",
  "ins.mst.uploadFailed": "Yükleme başarısız. Dosyayı kontrol edip tekrar deneyin.",
  "ins.mst.analyzing": "Yükleniyor ve analiz ediliyor…",
  "ins.mst.custom": "Özel",
  "ins.mst.render": "Master oluştur",
  "ins.mst.rerender": "Yeniden oluştur",
  "ins.mst.rendering": "Oluşturuluyor…",
  "ins.mst.dirty": "Son oluşturmadan beri ayarlar değişti — duymak için yeniden oluşturun.",
  "ins.mst.startFrom": "Başlangıç noktası",
  "ins.mst.genrePreset": "Tür preset'i…",
  "ins.mst.neutral": "Nötr",
  "ins.mst.revert": "Son oluşturmaya dön",
  "ins.mst.mod.eq": "Ekolayzer",
  "ins.mst.mod.compressor": "Kompresör",
  "ins.mst.mod.limiter": "Limiter",
  "ins.mst.mod.stereo": "Stereo genişlik",
  "ins.mst.mod.saturation": "Saturasyon",
  "ins.mst.mod.loudness": "Loudness normalizasyonu",
  "ins.mst.eqCurve": "EQ eğrisi — ayarlamak için noktaları sürükleyin",
  "ins.mst.lowCut": "Low cut",
  "ins.mst.freq": "Frek.",
  "ins.mst.gain": "Kazanç",
  "ins.mst.bandType.lowShelf": "Low shelf",
  "ins.mst.bandType.peaking": "Çan",
  "ins.mst.bandType.highShelf": "High shelf",
  "ins.mst.threshold": "Eşik",
  "ins.mst.ratio": "Oran",
  "ins.mst.makeup": "Makeup",
  "ins.mst.attack": "Atak",
  "ins.mst.release": "Bırakma",
  "ins.mst.knee": "Knee",
  "ins.mst.ceiling": "Tavan",
  "ins.mst.width": "Genişlik",
  "ins.mst.monoBass": "Mono bas",
  "ins.mst.drive": "Sürüş",
  "ins.mst.satType": "Saturasyon türü",
  "ins.mst.sat.tape": "Bant",
  "ins.mst.sat.tube": "Tüp",
  "ins.mst.sat.digital": "Yumuşak kırpma",
  "ins.mst.loudnessHint": "Hedefe ulaşmak için son kazanç aşaması. −14 LUFS; Spotify, YouTube ve Apple Music normalizasyonuyla eşleşir.",
  "ins.mst.meterShowing": "Ölçer gösteriyor: {source}",
  "ins.mst.historyTitle": "Mastering geçmişi",
  "ins.mst.historyDesc": "Hesabınızda saklanan tüm AI ve manuel masterlarınız.",
  "ins.mst.kpiTotal": "Toplam master",
  "ins.mst.kpiMinutes": "Master'lanan dakika",
  "ins.mst.typeAi": "AI",
  "ins.mst.typeManual": "Manuel",
  "ins.mst.all": "Tümü",
  "ins.mst.filter": "Türe göre filtrele",
  "ins.mst.search": "Dosya adına göre ara",
  "ins.mst.emptyTitle": "Henüz master yok",
  "ins.mst.emptyDesc": "İlk parçanızı birkaç dakikada AI ile master'layın — burada saklanacak.",
  "ins.mst.noMatch": "Filtrelerinize uyan master yok.",
  "ins.mst.colFile": "Dosya",
  "ins.mst.colType": "Tür",
  "ins.mst.colLoudness": "Ses yüksekliği",
  "ins.mst.colStatus": "Durum",
  "ins.mst.colActions": "İşlemler",
  "ins.mst.notRendered": "Oluşturulmadı",
  "ins.mst.open": "Aç",
  "ins.mst.deleted": "Master silindi",
  "ins.mst.deleteFailed": "Bu master silinemedi.",
  "ins.mst.deleteTitle": "Bu master silinsin mi?",
  "ins.mst.deleteDesc": "\"{name}\" ve master dosyası kalıcı olarak silinecek.",
};

const es = {
  "ins.mst.aiDesc": "Sube tu mezcla: la IA detecta el género, crea una cadena de mastering y genera un WAV listo para streaming.",
  "ins.mst.manualTitle": "Estudio de mastering",
  "ins.mst.manualDesc": "Ajusta la cadena tú mismo y compárala con el original en tiempo real.",
  "ins.mst.history": "Historial",
  "ins.mst.manual": "Estudio manual",
  "ins.mst.newFile": "Nuevo archivo",
  "ins.mst.progress": "Progreso",
  "ins.mst.step.upload": "Subir",
  "ins.mst.step.process": "Analizar y masterizar",
  "ins.mst.step.done": "Comparar y descargar",
  "ins.mst.dropAria": "Elige un archivo de audio para masterizar",
  "ins.mst.dropTitle": "Suelta tu mezcla aquí o haz clic para buscar",
  "ins.mst.clickToChange": "haz clic para cambiar",
  "ins.mst.unsupported": "Formato no compatible. Compatibles: {formats}",
  "ins.mst.effect": "Efecto creativo (opcional)",
  "ins.mst.start": "Iniciar mastering con IA",
  "ins.mst.outputNote": "Salida: WAV, con la misma frecuencia de muestreo que tu archivo.",
  "ins.mst.howTitle": "Cómo funciona",
  "ins.mst.how1": "Medimos la sonoridad (LUFS), la dinámica, el tempo y el balance tonal de tu mezcla.",
  "ins.mst.how2": "El perfil de género más cercano define EQ, compresión, saturación, anchura estéreo, limitador y objetivo de sonoridad.",
  "ins.mst.how3": "Comparas original y máster con A/B sin cortes y descargas el WAV.",
  "ins.mst.wantControl": "¿Quieres control total? Abre el estudio manual",
  "ins.mst.recent": "Másters recientes",
  "ins.mst.viewAll": "Ver todo",
  "ins.mst.noJobs": "Aún no hay másters: el primero aparecerá aquí.",
  "ins.mst.uploading": "Subiendo… {pct}%",
  "ins.mst.processing": "Analizando y masterizando…",
  "ins.mst.elapsed": "Transcurrido {time}",
  "ins.mst.processingNote": "Las pistas largas pueden tardar uno o dos minutos. Mantén esta pestaña abierta.",
  "ins.mst.processed": "Tu máster está listo",
  "ins.mst.processFailed": "El mastering falló. Inténtalo de nuevo.",
  "ins.mst.audioLoadFailed": "No se pudo cargar el audio para reproducirlo.",
  "ins.mst.jobLoadFailed": "No se pudo abrir este trabajo de mastering.",
  "ins.mst.downloadFailed": "La descarga falló. Inténtalo de nuevo.",
  "ins.mst.player": "Reproductor",
  "ins.mst.completed": "Completado",
  "ins.mst.detected": "Estilo detectado",
  "ins.mst.confidence": "Confianza",
  "ins.mst.estimatedTip": "Estimación heurística del análisis de audio: tómala como orientación, no como medición.",
  "ins.mst.analysisFallback": "El análisis automático falló para este archivo, así que se aplicó un perfil Pop por defecto.",
  "ins.mst.genreScores": "Coincidencia de género",
  "ins.mst.whatWeDid": "Qué ajustó la IA",
  "ins.mst.rec.loud": "Tu mezcla ya era fuerte: el limitador se aplicó con cuidado.",
  "ins.mst.rec.quiet": "Tu mezcla era baja: se aplicó un aumento notable de sonoridad.",
  "ins.mst.rec.wideDynamics": "Se detectó un rango dinámico amplio: se aumentó la compresión.",
  "ins.mst.rec.heavyBass": "Se detectaron graves fuertes: se ajustó la EQ para controlarlos.",
  "ins.mst.rec.bright": "Se detectaron agudos brillantes: se suavizaron ligeramente.",
  "ins.mst.rec.noisy": "Se detectó contenido ruidoso: se usó un procesamiento más suave.",
  "ins.mst.inputLoudness": "Sonoridad de entrada",
  "ins.mst.dynamicRange": "Rango dinámico",
  "ins.mst.brightness": "Brillo",
  "ins.mst.energy": "Distribución de energía",
  "ins.mst.low": "Graves",
  "ins.mst.mid": "Medios",
  "ins.mst.high": "Agudos",
  "ins.mst.beforeAfter": "Antes / después",
  "ins.mst.integrated": "Sonoridad integrada",
  "ins.mst.truePeak": "Pico real",
  "ins.mst.samplePeak": "Pico de muestra",
  "ins.mst.duration": "Duración",
  "ins.mst.target": "Objetivo de sonoridad",
  "ins.mst.peakWarn": "Un pico real por encima de −1 dBTP puede distorsionar tras la codificación de streaming.",
  "ins.mst.noWaveform": "Forma de onda no disponible para este archivo",
  "ins.mst.waveform": "Forma de onda: usa las flechas para desplazarte",
  "ins.mst.appliedChain": "Cadena aplicada",
  "ins.mst.bands": "{n} bandas",
  "ins.mst.downloadMaster": "Descargar máster (WAV)",
  "ins.mst.downloadOriginal": "Descargar original",
  "ins.mst.fineTune": "Ajustar en el estudio manual",
  "ins.mst.restart": "Volver al inicio",
  "ins.mst.play": "Reproducir",
  "ins.mst.pause": "Pausa",
  "ins.mst.abCompare": "Comparación A/B",
  "ins.mst.abHint": "Pulsa A para el original y B para el máster: la reproducción continúa en el mismo punto.",
  "ins.mst.uploaded": "Archivo subido y analizado",
  "ins.mst.uploadFailed": "La subida falló. Revisa el archivo e inténtalo de nuevo.",
  "ins.mst.analyzing": "Subiendo y analizando…",
  "ins.mst.custom": "Personalizado",
  "ins.mst.render": "Generar máster",
  "ins.mst.rerender": "Volver a generar",
  "ins.mst.rendering": "Generando…",
  "ins.mst.dirty": "Los ajustes cambiaron desde la última generación: vuelve a generar para escucharlos.",
  "ins.mst.startFrom": "Empezar desde",
  "ins.mst.genrePreset": "Preset de género…",
  "ins.mst.neutral": "Neutro",
  "ins.mst.revert": "Volver a la última generación",
  "ins.mst.mod.eq": "Ecualizador",
  "ins.mst.mod.compressor": "Compresor",
  "ins.mst.mod.limiter": "Limitador",
  "ins.mst.mod.stereo": "Anchura estéreo",
  "ins.mst.mod.saturation": "Saturación",
  "ins.mst.mod.loudness": "Normalización de sonoridad",
  "ins.mst.eqCurve": "Curva de EQ: arrastra los puntos para ajustar",
  "ins.mst.lowCut": "Corte de graves",
  "ins.mst.freq": "Frec.",
  "ins.mst.gain": "Ganancia",
  "ins.mst.bandType.lowShelf": "Shelf grave",
  "ins.mst.bandType.peaking": "Campana",
  "ins.mst.bandType.highShelf": "Shelf agudo",
  "ins.mst.threshold": "Umbral",
  "ins.mst.ratio": "Ratio",
  "ins.mst.makeup": "Ganancia",
  "ins.mst.attack": "Ataque",
  "ins.mst.release": "Relajación",
  "ins.mst.knee": "Rodilla",
  "ins.mst.ceiling": "Techo",
  "ins.mst.width": "Anchura",
  "ins.mst.monoBass": "Graves mono",
  "ins.mst.drive": "Drive",
  "ins.mst.satType": "Tipo de saturación",
  "ins.mst.sat.tape": "Cinta",
  "ins.mst.sat.tube": "Válvula",
  "ins.mst.sat.digital": "Soft clip",
  "ins.mst.loudnessHint": "Etapa final de ganancia para alcanzar el objetivo. −14 LUFS coincide con la normalización de Spotify, YouTube y Apple Music.",
  "ins.mst.meterShowing": "El medidor muestra: {source}",
  "ins.mst.historyTitle": "Historial de mastering",
  "ins.mst.historyDesc": "Todos tus másters con IA y manuales, guardados en tu cuenta.",
  "ins.mst.kpiTotal": "Másters totales",
  "ins.mst.kpiMinutes": "Minutos masterizados",
  "ins.mst.typeAi": "IA",
  "ins.mst.typeManual": "Manual",
  "ins.mst.all": "Todos",
  "ins.mst.filter": "Filtrar por tipo",
  "ins.mst.search": "Buscar por nombre de archivo",
  "ins.mst.emptyTitle": "Aún no hay másters",
  "ins.mst.emptyDesc": "Masteriza tu primera pista con IA en un par de minutos: se guardará aquí.",
  "ins.mst.noMatch": "Ningún máster coincide con tus filtros.",
  "ins.mst.colFile": "Archivo",
  "ins.mst.colType": "Tipo",
  "ins.mst.colLoudness": "Sonoridad",
  "ins.mst.colStatus": "Estado",
  "ins.mst.colActions": "Acciones",
  "ins.mst.notRendered": "Sin generar",
  "ins.mst.open": "Abrir",
  "ins.mst.deleted": "Máster eliminado",
  "ins.mst.deleteFailed": "No se pudo eliminar este máster.",
  "ins.mst.deleteTitle": "¿Eliminar este máster?",
  "ins.mst.deleteDesc": "\"{name}\" y su archivo masterizado se eliminarán permanentemente.",
};

export default { en, tr, es };
